// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'clipboard-solid';

export const Component = () => (
  <path d='M6.928 4.406V2.443c0-.335.192-.479.527-.479h.479v-.479c0-.431.143-.766.43-1.054A1.408 1.408 0 0 1 9.42 0h5.843c.431 0 .766.144 1.054.431.287.288.43.623.43 1.054v.48h.48c.335 0 .526.143.526.478v1.963c0 .335-.191.48-.526.48h-9.77c-.336 0-.527-.145-.527-.48Zm13.267-1.484h-1.58c.047.191.095.383.095.526v.958c0 .432-.144.767-.431 1.054a1.408 1.408 0 0 1-1.054.431h-9.77c-.432 0-.767-.143-1.054-.43a1.408 1.408 0 0 1-.431-1.055v-.958c0-.143.047-.335.096-.526h-1.58c-.432 0-.767.144-1.055.431A1.408 1.408 0 0 0 3 4.407v18.63c0 .432.144.767.431 1.054.288.288.623.432 1.054.432h15.709c.431 0 .766-.144 1.054-.432.287-.287.43-.622.43-1.053V4.407a1.41 1.41 0 0 0-.43-1.054 1.408 1.408 0 0 0-1.054-.431Z' />
);

export const viewBox = '0 0 25 25';
